import {
  AppointmentTypeDto,
  CreateAppointmentTypeDto,
  MeetCapabilityDto,
  SaveBookingQuestionsDto,
  SaveBookingQuestionsResponseDto,
  UpdateAppointmentTypeDto,
} from '../core/appointment-types';
import { HttpClient } from './http';

export interface AppointmentTypesService {
  list: (userId: string) => Promise<AppointmentTypeDto[]>;
  getDefault: (userId: string) => Promise<AppointmentTypeDto | null>;
  create: (dto: CreateAppointmentTypeDto) => Promise<AppointmentTypeDto>;
  update: (id: string, dto: UpdateAppointmentTypeDto) => Promise<void>;
  saveBookingQuestions: (
    id: string,
    dto: SaveBookingQuestionsDto,
  ) => Promise<SaveBookingQuestionsResponseDto>;
  delete: (id: string) => Promise<void>;
  setAsDefault: (id: string) => Promise<void>;
  getMeetCapability: (calendarId: string) => Promise<MeetCapabilityDto>;
}

export function createAppointmentTypesService(
  http: HttpClient,
  baseUrl: string,
): AppointmentTypesService {
  return {
    list: (userId: string) => {
      return http<AppointmentTypeDto[]>(
        `${baseUrl}/appointment-types/${userId}`,
        'get',
      );
    },

    getDefault: (userId: string) => {
      return http<AppointmentTypeDto | null>(
        `${baseUrl}/appointment-types/${userId}/default`,
        'get',
      );
    },

    create: (dto: CreateAppointmentTypeDto) => {
      return http<AppointmentTypeDto>(`${baseUrl}/appointment-types`, 'post', {
        body: dto,
      });
    },

    update: (id: string, dto: UpdateAppointmentTypeDto) => {
      return http<void>(`${baseUrl}/appointment-types/${id}`, 'patch', {
        body: dto,
      });
    },

    saveBookingQuestions: (id: string, dto: SaveBookingQuestionsDto) => {
      return http<SaveBookingQuestionsResponseDto>(
        `${baseUrl}/appointment-types/${id}/booking-questions`,
        'put',
        { body: dto },
      );
    },

    delete: (id: string) => {
      return http<void>(`${baseUrl}/appointment-types/${id}`, 'delete');
    },

    setAsDefault: (id: string) => {
      return http<void>(
        `${baseUrl}/appointment-types/${id}/set-as-default`,
        'post',
      );
    },

    getMeetCapability: (calendarId: string) => {
      return http<MeetCapabilityDto>(
        `${baseUrl}/appointment-types/calendars/${calendarId}/meet-capability`,
        'get',
      );
    },
  };
}
